import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

export default {
  editButton: (theme: Theme) => css`
    border-radius: ${theme.shape.borderRadiusLarge}px;
    border: 1px solid ${theme.mui.palette.primary.main};
    width: 14rem;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.16);
    .MuiInput-input {
      padding: ${theme.mui.spacing(1)}px 0 ${theme.mui.spacing(1)}px
        ${theme.mui.spacing(2)}px;
      text-align: center;
      color: ${theme.mui.palette.primary.main};
      font-weight: ${theme.mui.typography.fontWeightBold};
    }
  `,
  editIcon: (theme: Theme) => css`
    &.MuiSvgIcon-root {
      font-size: ${theme.mui.typography.body1.fontSize};
      margin: ${theme.mui.spacing(1)}px;
      color: ${theme.mui.palette.primary.main};
    }
  `,
};
